import { styled } from "styled-components"
import LoadInView from "../common/LoadInView"
import { toast } from "react-toastify"
import { StyledButton } from "../common/Buttons"
import { TextDiv } from "../common/Text"
import { useQuizEnd } from "../../hooks/QuizPage/useQuizEnd"
import { useResetRecoilState } from "recoil"
import quizPhaseState from "../../recoil/quizPhase"
import quizPreinfoState from "../../recoil/quizPreinfo"
import {
  quizItemsState,
  quizResponseListState,
} from "../../recoil/QuizPage/atoms"

const QuizSubmit = () => {
  const resetQuizPhase = useResetRecoilState(quizPhaseState)
  const resetQuizPreinfo = useResetRecoilState(quizPreinfoState)
  const resetQuizItems = useResetRecoilState(quizItemsState)
  const resetQuizResponseList = useResetRecoilState(quizResponseListState)

  const submitResponse = () => {
    toast.success("답변을 제출하였습니다. 잠시 후 검사 결과로 넘어갑니다.")
    quizEnd()
    resetQuizPhase()
    resetQuizPreinfo()
    resetQuizItems()
    resetQuizResponseList()
  }

  const { mutate: quizEnd } = useQuizEnd()
  console.log('지훈요청: 폭죽터트리는 축하그림 transition 주면서 보여지면 좋을듯: 참고(https://cdn4.iconfinder.com/data/icons/party-and-celebration-4/65/85-512.png)')
  return (
    <LoadInView>
      <QuizSubmitDiv>
        <TextDiv fontSize={20} fontWeight="bold">
          모든 문항에 응답을 완료했습니다. 제출하시겠습니까?
        </TextDiv>
        <StyledButton $size="large" onClick={submitResponse}>
          제출하고 검사결과 받아보기
        </StyledButton>
      </QuizSubmitDiv>
    </LoadInView>
  )
}

export default QuizSubmit

const QuizSubmitDiv = styled.div`
  display: flex;
  height: calc(100vh - 130px);
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 100px;
`
